export default [
    {
        path: 'gerenciamento',
        component: () => import(
            '@/views/transporte-paciente/gerenciamento/Index'
        ),
        redirect: 'gerenciamento/list',
        children: [
            {
                name: 'transporte-paciente-gerenciamento-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/gerenciamento/List'
                ),
            },
            {
                name: 'transporte-paciente-gerenciamento-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/gerenciamento/Form'
                ),
            },
        ],
    },
]